import { useDispatch, useSelector } from '@redux';
import { completePick } from '@redux/ordersDetail/actions';
import { Button } from 'antd';
import { some } from 'lodash';
import React, { useState } from 'react';
import { DynamicObjectType } from 'types/commons';

const ButtonCompletePick = () => {
  const dispatch = useDispatch();

  const currentBatch = useSelector<DynamicObjectType>(
    (state) => state.orderBatches.currentData,
  );

  const [loading, setLoading] = useState(false);

  const handleCompletePick = async () => {
    try {
      setLoading(true);
      await dispatch(
        completePick({
          data: { id: currentBatch?.id },
          options: {
            isShowSuccessNoti: true,
          },
        }),
      );
      setLoading(false);
      window.location.reload();
    } catch {
      setLoading(false);
    }
  };

  return (
    <Button
      type="primary"
      onClick={handleCompletePick}
      loading={loading}
      disabled={some(currentBatch?.batchItems, (item) => !item?.isPicked)}
    >
      Complete Pick
    </Button>
  );
};

export default ButtonCompletePick;
